import { render, staticRenderFns } from "./FooterTab.vue?vue&type=template&id=0d94d4d4&scoped=true"
import script from "./FooterTab.vue?vue&type=script&lang=js"
export * from "./FooterTab.vue?vue&type=script&lang=js"
import style0 from "./FooterTab.vue?vue&type=style&index=0&id=0d94d4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94d4d4",
  null
  
)

export default component.exports